import React from "react";
import {TaxonomyEditorPage} from "./TaxonomyEditorPage";

export const TaxonomyEditorViewOnlyPage: React.FC = () => <TaxonomyEditorPage viewer={true}/>
